/**
 * Kept as a no-op shell for the landing composition. The photo-led Hero owns
 * the transparent header so nav text stays legible over the image.
 */
export function MarketingHeader() {
  return null;
}
